import { Button, Descriptions, Spin } from 'antd';

import { Role } from '@app/domain-interfaces';
import { Auth, Tables } from '@app/web-components';

import { EmployeeTypeRenderer } from '../../common';
import { useFindBundleById } from '../data';
import { ProductFamilyHierarchyPopover } from '../modals';

export type HeaderProps = {
  bundleId: number;
};

export const Header = ({ bundleId }: HeaderProps) => {
  const { user } = Auth.useUserAuth();
  const { data, error, isPending, isFetching } = useFindBundleById({ bundleId });

  if (error) {
    throw error;
  }

  if (isPending || isFetching) {
    return <Spin style={{ width: '100%' }}>{/* <div style={{ height: '100vh' }} /> */}</Spin>;
  }

  const bundle = data;
  const showProductFamilyPopover = !!user?.roles[Role.BUNDLE_ADMIN] || !!user?.roles[Role.RULE_ADMIN];

  return (
    <Descriptions size="small" column={{ xxl: 3, xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }} style={{ maxWidth: 1000 }}>
      <Descriptions.Item label="Active">
        <Tables.BooleanRenderer value={bundle.isActive} />
      </Descriptions.Item>
      <Descriptions.Item label="Employee Type">
        <EmployeeTypeRenderer employeeType={bundle.employeeType} />
      </Descriptions.Item>
      {bundle.productFamily && (
        <Descriptions.Item label="Product Family">
          {bundle.productFamily ? (
            showProductFamilyPopover ? (
              <ProductFamilyHierarchyPopover
                productFamilyId={bundle.productFamily.id}
                productFamilyName={bundle.productFamily.name}
              >
                <Button type="link" size="small" style={{ padding: 0 }}>
                  {bundle.productFamily.name}
                </Button>
              </ProductFamilyHierarchyPopover>
            ) : (
              bundle.productFamily.name
            )
          ) : undefined}
        </Descriptions.Item>
      )}
    </Descriptions>
  );
};
